<template>
  <div id="app" v-if="$store.getters.getCountryList.length>0">
      <Header v-if="isAuthActive"/>

      <el-container style="min-height: 100vh;">
        
        <el-main>
          <router-view style="top: 10px; position: relative;"/>
        </el-main> 

        <br><br><br><br><br>
        <el-footer>
          <span style="font-size: 10px;" v-html="'2017-'+new Date().getFullYear()+' &copy; Raizzon Infotech LLP, All Rights Reserved.'">
            
          </span>
        </el-footer>      
      </el-container>
      <el-backtop>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <span style="font-weight: bold;"><i class="el-icon-arrow-up"></i> UP</span>
        </div>
       
      </el-backtop>
       
  </div>
  <div id="app" v-else style="width: 100%; text-align: center;">
    <h1>Loading...</h1>
  </div>
</template>

<script>
//import { ipcRenderer  } from "electron";
import Header from './components/Header.vue'

export default {
  components: {Header},
  data() {
    return {
    }
  },
  computed: {
    isAuthActive() {
      return this.$store.getters.isAuthenticated
    },
    getWindowObject() {
      return this.win
    },
    getAccessToken() {
      return localStorage.getItem('accessToken')        
    }
  },
  methods: {
      setDefaultProperties() {
        if(this.getAccessToken !== null && this.getAccessToken.length > 0) {
          this.$store.dispatch('checkAccessToken', {navigate: false})
        } else {
          this.$store.dispatch('loadCountryList')
        }
        
      }
  },
  mounted() {
    setTimeout(() => {
        this.setDefaultProperties()
    }, 2000);
    window.scroll(0, 0)
  }
}


</script>


<style>
body {
  font-size: 13px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: #383838;
  -moz-osx-font-smoothing: #383838;
  text-align: center;
  color: #383838;  
}

#app {
  width: 100wh;  
}

.rowFontSize {
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue